<template>
  <div class="custom-file">
    <input type="file"
           class="custom-file-input"
           id="customFileLang"
           lang="en"
           v-bind="$attrs"
           v-on="listeners"
           ref="customFileInput"
           :accept="accept"
    />
    <label class="custom-file-label" for="customFileLang">
      {{label}}
    </label>
  </div>
</template>
<script>
  export default {
    name: 'file-input',
    inheritAttrs: false,
    props: {
      initialLabel: {
        type: String,
        default: 'Select file'
      },
      accept: {
        type: String,
        default: null
      }
    },
    data() {
      return {
        files: []
      }
    },
    computed: {
      listeners() {
        return {
          ...this.$listeners,
          change: this.fileChange
        }
      },
      label() {
        let fileNames = [];
        for (let file of this.files) {
          fileNames.push(file.name)
        }
        return fileNames.length ? fileNames.join(', ') : this.initialLabel
      }
    },
    methods: {

      fileChange(evt) {
        this.files = evt.target.files
        this.$emit('change', this.files)
      },
      
      trigger() {
        this.$refs.customFileInput.click()
      },
      
      reset() {
        this.$refs.customFileInput.value = null
      },
    }
  }
</script>
<style>
</style>
